export default {
    name: "Tooltip",
    props: {
        text: {
            type: String,
            default: null
        },
        animation: {
            type: Boolean,
            default: false
        },
        position: {
            type: String,
            required: false,
            default: 'top-right'
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/tooltip/tooltip.js